// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/DashboardLayout';
import Home from './components/Home';
import About from './components/About';
import Resources from './components/Resources';
import Monitor from './components/Monitor';
import Contact from './components/Contact';
import EndPier1 from './components/EndPier1';
import EndPier4 from './components/EndPier4';
import ComparePiers from './components/ComparePiers';
import Superstructure from './components/Superstructure';
import LowerSuperstructure from './components/LowerSuperstructure';
import Pylon2LeftLeg from './components/Pylon2LeftLeg';
import Pylon2RightLeg from './components/Pylon2RightLeg';
import Pylon3LeftLeg from './components/Pylon3LeftLeg';
import Pylon3RightLeg from './components/Pylon3RightLeg';
import MOM from './components/MOM';
import DataaaaAnalysis from './components/DataaaaAnalysis';
import B27RegimeAdaptation from './components/B27RegimeAdaptation';
import B27RegimeRolling from './components/B27RegimeRolling';
import { isInternalPagesHost } from './utils/internalPages';

function App() {
  // Localhost only — never on the public site URL (even if env flag is mis-set).
  const showInternalPages = isInternalPagesHost();

  return (
    <Router>
      <Dashboard />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/mom"
          element={showInternalPages ? <MOM /> : <Navigate to="/" replace />}
        />
        <Route
          path="/dataaaa-analysis"
          element={showInternalPages ? <DataaaaAnalysis /> : <Navigate to="/" replace />}
        />
        <Route
          path="/b27-regime-adaptation"
          element={showInternalPages ? <B27RegimeAdaptation /> : <Navigate to="/" replace />}
        />
        <Route
          path="/b27-regime-rolling"
          element={showInternalPages ? <B27RegimeRolling /> : <Navigate to="/" replace />}
        />
        <Route path="/monitor" element={<Monitor />}>
          <Route index element={<></>} />
          <Route path="first-place" element={<Navigate to="/monitor/end-pier-1" replace />} />
          <Route path="second-place" element={<Navigate to="/monitor/end-pier-4" replace />} />
          <Route path="end-pier-1" element={<EndPier1 />} />
          <Route path="end-pier-4" element={<EndPier4 />} />
          <Route path="compare" element={<ComparePiers />} />
          <Route path="superstructure" element={<Superstructure />} />
          <Route path="tower1" element={<LowerSuperstructure />} />
          <Route path="pylon2-left-leg" element={<Pylon2LeftLeg />} />
          <Route path="pylon2-right-leg" element={<Pylon2RightLeg />} />
          <Route path="pylon3-left-leg" element={<Pylon3LeftLeg />} />
          <Route path="pylon3-right-leg" element={<Pylon3RightLeg />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;

